import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, MessagesSquare, TrendingUp } from "lucide-react";

const FEATURES = [
    {
        Icon: CalendarCheck,
        title: "Weekly check-ins",
        body: "Klair pings you every Sunday with one question that matters.",
    },
    {
        Icon: MessagesSquare,
        title: "Honest feedback",
        body: "When you're drifting, Klair says it. Kindly. Directly.",
    },
    {
        Icon: TrendingUp,
        title: "Real progress",
        body: "Track your 90-day plan with concrete weekly wins, not vibes.",
    },
];

export function AccountabilitySection() {
    return (
        <div data-testid="accountability-section">
            <div className="text-center max-w-2xl mx-auto">
                <div className="text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-klareet-T">
                    Why Klareet is different
                </div>
                <h2
                    className="mt-3 text-3xl md:text-5xl font-bold tracking-tight text-klareet-TEXT leading-[1.05]"
                    data-testid="accountability-headline"
                >
                    We don't just hand you a snapshot.
                </h2>
                <p className="mt-6 text-base md:text-lg text-klareet-MUT leading-relaxed">
                    Most career tools end at the snapshot. We start there. Klair
                    builds your 90-day plan, then checks in every week to make
                    sure you're actually doing it. Weekly nudges. Honest
                    feedback. Real progress. Not another file in your
                    downloads folder.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12 md:mt-16">
                {FEATURES.map(({ Icon, title, body }, i) => (
                    <motion.div
                        key={title}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{
                            duration: 0.45,
                            delay: i * 0.08,
                            ease: [0.2, 0.8, 0.2, 1],
                        }}
                        whileHover={{ y: -3 }}
                        className="group rounded-2xl border border-klareet-bor bg-klareet-NAVY p-7 hover:border-klareet-T transition-colors"
                        data-testid={`accountability-card-${i + 1}`}
                    >
                        <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-klareet-T/12 group-hover:bg-klareet-T/25 transition-colors">
                            <Icon
                                size={22}
                                strokeWidth={2}
                                className="text-klareet-T2"
                            />
                        </span>
                        <div className="mt-5 text-[15px] font-semibold tracking-tight text-klareet-TEXT">
                            {title}
                        </div>
                        <p className="mt-2 text-sm text-klareet-MUT leading-relaxed">
                            {body}
                        </p>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
